module.exports = __webpack_public_path__ + "static/media/slider-agency-website-slide-01-macbook-frame.7087d3e6.png";